import React from "react";

const Row = ({ children, row = "g-4 mb-4" }) => {
    return <div className={`row ${row}`}>{children}</div>;
};

export default Row;
